import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IWlocDetail, IWlocSearch } from "./wlocTypes";


class WlocService {
    async page(searchVo: IWlocSearch, config: object = {}) {
        const apiUrl = "/gtm/warning/credit/search/pg";
        return await httpRequest.post<IPage<IWlocDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: IWlocSearch) {
        const appPageUrl = "/gtm/warning/credit/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

}

export const wlocService = new WlocService();
